import baseColumns from './base-columns';

export default function SocialMediaColumns(params: any) {
  const { filterBoxValue, gameInfo } = params;
  const { languages } = filterBoxValue;

  const languageSort = ['origin', 'en', 'zh'];
  const languageList = languageSort.filter((a: any) => languages.includes(a));

  const { entity_type = 'mobile' } = gameInfo;

  if (entity_type === 'pc') {
    return baseColumns(
      [
        {
          key: 'channelName',
        },
        'rating',
        ...languageList,
        'validation',
        'monitorSource',
        'commentTime',
        'language',
        'topic',
      ],
      {
        ...params,
        ...filterBoxValue,
        entityType: entity_type,
        firstLanguage: languageList[0],
      },
    );
  }

  if (entity_type === 'console') {
    return baseColumns(
      [
        {
          key: 'channelName',
        },
        'rating',
        ...languageList,
        'validation',
        'monitorSource',
        'commentTime',
        'language',
        'topic',
        'feedsPlatform',
      ],
      {
        ...params,
        ...filterBoxValue,
        firstLanguage: languageList[0],
        entityType: entity_type,
      },
    );
  }

  return baseColumns(
    [
      {
        key: 'channelName',
      },
      'rating',
      ...languageList,
      'validation',
      'commentTime',
      'market',
      'version',
      'topic',
    ],
    {
      ...params,
      ...filterBoxValue,
      firstLanguage: languageList[0],
      entityType: entity_type,
    },
  );
}
